// Chat Store — Zustand global state for direct messaging
// KHLIFI HOUCEM / FORMATEUR CLOUD && DEVSECOPS
import { create } from "zustand";

const useChatStore = create((set, get) => ({
  // Chat dialog state
  chatOpen: false,
  chatTarget: null, // { id, first_name, last_name, avatar, role }
  activeConversationId: null,

  // Unread counts
  totalUnread: 0,
  unreadByConversation: {},

  // Incoming notification bubble
  notification: null, // { message, sender, conversationId }

  // Actions
  openChat: (targetUser, conversationId = null) =>
    set({
      chatOpen: true,
      chatTarget: targetUser,
      activeConversationId: conversationId,
    }),

  closeChat: () =>
    set({
      chatOpen: false,
      chatTarget: null,
      activeConversationId: null,
    }),

  setActiveConversation: (id) =>
    set({ activeConversationId: id }),

  // Unread management
  setUnreadCounts: (total, byConversation) =>
    set({
      totalUnread: total,
      unreadByConversation: byConversation || {},
    }),

  decrementUnread: (conversationId) => {
    const state = get();
    const convUnread = state.unreadByConversation[conversationId] || 0;
    if (convUnread <= 0) return;
    
    const newByConv = { ...state.unreadByConversation };
    delete newByConv[conversationId];
    
    set({
      totalUnread: Math.max(0, state.totalUnread - convUnread),
      unreadByConversation: newByConv,
    });
  },

  incrementUnread: (conversationId) => {
    const state = get();
    const newByConv = { ...state.unreadByConversation };
    newByConv[conversationId] = (newByConv[conversationId] || 0) + 1;
    
    set({
      totalUnread: state.totalUnread + 1,
      unreadByConversation: newByConv,
    });
  },

  // Notification bubble
  showNotification: (data) =>
    set({ notification: data }),

  clearNotification: () =>
    set({ notification: null }),
}));

export default useChatStore;
